import { Component, createRef } from 'react';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import { apiPost, handleApiError } from '../../common';
import UploadWithProgress from './upload-with-progress';
import FileUploader from './file_uploader';

class FileUploaderWithProgress extends Component {
  state = {
    name,
    currentUpload: null,
    uploadFailed: false,
  };

  constructor(props) {
    super(props);
    this.inputRef = createRef();
    this.linkRef = createRef();
    this.imgRef = createRef();
  }

  componentDidMount() {
    const fileElem = $(this.inputRef.current);
    const fileSelect = $(this.linkRef.current);
    const img = $(this.imgRef.current);

    fileSelect.on('click', (e) => {
      if (fileElem) {
        fileElem.click();
      }
      e.preventDefault();
    });

    img.on('click', (e) => {
      if (fileElem) {
        fileElem.click();
      }
      e.preventDefault();
    });
  }

  render() {
    if (this.state.uploadFailed) {
      return (
        <div className="flex">
          <div className="red mrm file-uploader-error">Error Uploading!</div>
          <FileUploader handler={this.handler} title="Try Again?" />
        </div>
      );
    }
    if (this.state.currentUpload) {
      const upload = this.state.currentUpload;
      return (
        <UploadWithProgress
          data={upload.data}
          url={upload.url}
          name={upload.name}
          key={upload.url}
          method="PUT"
          uploadCompleted={this.uploadCompleted(upload.name, upload.folder)}
          uploadFailed={this.uploadFailed}
          isBinaryUpload
        />
      );
    }
    const fileUploaderProps = {
      handler: this.handler,
      title: this.props.title,
      showImgLink: this.props.showImgLink,
    };
    if (this.props.accept) {
      fileUploaderProps.accept = this.props.accept;
    }
    return <FileUploader {...fileUploaderProps} />;
  }

  handler = (e) => {
    e.preventDefault();
    const me = this;
    const file = e.target.files[0];

    const { filter, failedFilterMessage, alertMethod } = this.props;
    if (typeof filter === 'function' && !filter(file.name)) {
      if (alertMethod) {
        alertMethod(failedFilterMessage);
      } else {
        WRModals.alert(failedFilterMessage);
      }
      return;
    }

    const parent = $(e.target).parent();
    parent.trigger('reset');

    apiPost(
      this.props.prepareUploadUrl,
      { file_name: file.name },
      (result) => {
        me.state.currentUpload = {
          data: file,
          url: result.url,
          name: result.file_name,
          contentType: result.content_type,
          folder: result.folder_name,
        };

        me.setState({
          currentUpload: me.state.currentUpload,
          uploadFailed: false,
        });
      },
      handleApiError(),
    );
  };

  uploadCompleted = (file_name, folder_name) => {
    const me = this;
    return (result, url) => {
      const data = { file_name, folder_name };
      if (me.props.uploadCompletedUrl) {
        apiPost(
          me.props.uploadCompletedUrl,
          data,
          (result) => {
            me.props.uploadCompleted(result, url, data);
            me.setState({ currentUpload: null });
          },
          handleApiError(),
        );
      } else {
        me.props.uploadCompleted(result, url, data);
        me.setState({ currentUpload: null });
      }
    };
  };

  uploadFailed = () => {
    this.setState({
      currentUpload: null,
      uploadFailed: true,
    });
  };
}

export default FileUploaderWithProgress;
